const createProjectDialog = {
  title: "Stofna nýtt verkefni",
  titleLabel: "Heiti verkefnis *",
  titlePlaceholder: "t.d. Hjarta- og æðarannsókn",
  descriptionLabel: "Lýsing verkefnis *",
  creating: "Stofna...",
  submit: "Stofna verkefni",
  errors: {
    titleRequired: "Heiti verkefnis er nauðsynlegt",
    descriptionRequired: "Lýsing verkefnis er nauðsynleg",
    createFailed: "Ekki tókst að stofna verkefni",
  },
};

export default createProjectDialog;
